import { unitUpdateList } from "./unitUpdateList";

export class updateunitdetailsrequest {
  bulkUpdate: boolean;
  updatedList: unitUpdateList[];
}
